import React, { useEffect, useState } from 'react';
const NAMES = ['Carlos', 'Rodrigo', 'Diego', 'Martín', 'Andrés', 'Juan', 'Sebastián', 'Mateo', 'Santiago', 'Felipe', 'Nicolás', 'Gabriel', 'Daniel', 'Javier', 'Alejandro', 'Pablo', 'Fernando', 'Ricardo', 'Lucas', 'Emiliano', 'Camila', 'Valentina', 'Sofía', 'Daniela', 'Mariana', 'Lucía', 'Paula'];
const CITIES = ['Ciudad de México 🇲🇽', 'Guadalajara 🇲🇽', 'Monterrey 🇲🇽', 'Buenos Aires 🇦🇷', 'Córdoba 🇦🇷', 'Rosario 🇦🇷', 'Bogotá 🇨🇴', 'Medellín 🇨🇴', 'Cali 🇨🇴', 'Madrid 🇪🇸', 'Barcelona 🇪🇸', 'Sevilla 🇪🇸', 'Santiago 🇨🇱', 'Lima 🇵🇪', 'Quito 🇪🇨', 'Montevideo 🇺🇾', 'Caracas 🇻🇪', 'Asunción 🇵🇾', 'San José 🇨🇷', 'Guatemala 🇬🇹'];
const PRODUCTS = [{
  name: 'FÚTBOL LISTO 360',
  emoji: '⚽'
}];
const LETTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
interface NotificationData {
  name: string;
  initial: string;
  city: string;
  product: {
    name: string;
    emoji: string;
  };
  timeAgo: number;
}
function generateRandomNotification(): NotificationData {
  const name = NAMES[Math.floor(Math.random() * NAMES.length)];
  const initial = LETTERS[Math.floor(Math.random() * LETTERS.length)];
  const city = CITIES[Math.floor(Math.random() * CITIES.length)];
  const product = PRODUCTS[Math.floor(Math.random() * PRODUCTS.length)];
  const timeAgo = Math.floor(Math.random() * 14) + 2;
  return {
    name,
    initial,
    city,
    product,
    timeAgo
  };
}
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  const [notification, setNotification] = useState<NotificationData | null>(null);
  useEffect(() => {
    if (isDismissed) return;
    let showTimeout: ReturnType<typeof setTimeout>;
    let hideTimeout: ReturnType<typeof setTimeout>;
    const cycleNotification = () => {
      setNotification(generateRandomNotification());
      setIsVisible(true);
      hideTimeout = setTimeout(() => {
        setIsVisible(false);
        const nextDelay = 25000 + Math.floor(Math.random() * 20000);
        showTimeout = setTimeout(cycleNotification, nextDelay);
      }, 4000);
    };
    const initialTimeout = setTimeout(cycleNotification, 20000);
    return () => {
      clearTimeout(initialTimeout);
      clearTimeout(showTimeout);
      clearTimeout(hideTimeout);
    };
  }, [isDismissed]);
  if (isDismissed || !notification) return null;
  return <div className={`fixed bottom-4 left-4 z-50 transition-all duration-500 ease-in-out ${isVisible ? 'translate-x-0 opacity-100' : '-translate-x-full opacity-0'}`} data-id="element-181">
      <div className="bg-white border border-[#E5E5EA] rounded-2xl shadow-2xl p-4 max-w-[300px] sm:max-w-[320px] relative pr-8" data-id="element-182">
        <button onClick={() => setIsDismissed(true)} className="absolute top-2 right-2 text-[#5A5A66] hover:text-[#0A0A0A] transition-colors p-1" aria-label="Cerrar notificación" data-id="element-183">
          ✕
        </button>
        <div className="flex items-center gap-2 mb-2" data-id="element-184">
          <div className="w-2 h-2 bg-[#00A650] rounded-full animate-pulse" data-id="element-185" />
          <span className="text-[#00A650] text-[10px] font-black uppercase tracking-widest" data-id="element-186">
            Compra verificada
          </span>
        </div>
        <p className="text-[#0A0A0A] text-sm mb-1 font-medium" data-id="element-187">
          <span className="font-black" data-id="element-188">
            {notification.name} {notification.initial}.
          </span>{' '}
          de {notification.city}
        </p>
        <p className="text-[#5A5A66] text-sm mb-2 font-medium" data-id="element-189">
          compró{' '}
          <span className="text-[#00A650] font-black" data-id="element-190">
            {notification.product.name} {notification.product.emoji}
          </span>
        </p>
        <p className="text-[#5A5A66] opacity-70 text-xs font-bold" data-id="element-191">
          hace {notification.timeAgo} minutos
        </p>
      </div>
    </div>;
}